interface Props {
  meta: { generatedAt?: string; generated_at?: string };
  /** Minutes before feed is considered stale. Default: 240 (4 hours). */
  staleAfterMinutes?: number;
}

function ageLabel(generatedAt: string): { label: string; stale: boolean } {
  const generated = new Date(generatedAt);
  if (isNaN(generated.getTime())) {
    return { label: 'neznámý čas', stale: true };
  }
  const diffMs = Date.now() - generated.getTime();
  const diffMin = Math.floor(diffMs / 60_000);

  if (diffMin < 1) return { label: 'právě teď', stale: false };
  if (diffMin < 60) return { label: `před ${diffMin} min`, stale: false };
  const diffH = Math.floor(diffMin / 60);
  if (diffH < 24) return { label: `před ${diffH} h`, stale: diffH >= 4 };
  const diffD = Math.floor(diffH / 24);
  return { label: `před ${diffD} dny`, stale: true };
}

export function StaleIndicator({ meta, staleAfterMinutes = 240 }: Props) {
  const generatedAt = meta.generatedAt ?? meta.generated_at ?? '';
  const generated = new Date(generatedAt);
  const isStale =
    isNaN(generated.getTime()) ||
    (Date.now() - generated.getTime()) / 60_000 > staleAfterMinutes;

  const { label } = ageLabel(generatedAt);

  return (
    <span className={`stale-indicator ${isStale ? 'stale-indicator--stale' : 'stale-indicator--ok'}`}>
      {isStale ? 'Poslední snapshot' : 'Data aktualizována'} · {label}
    </span>
  );
}
